/**
 * Normalizer for the Manage Events listing (POST external-events/filter).
 *
 * The filter API now returns a trimmed response shape — bind only the fields
 * it actually sends. No legacy PascalCase/synonym fallbacks: those fields no
 * longer exist in this response, so guessing at alternates would fabricate
 * data instead of reflecting what the API returned.
 *
 * This is separate from eventFormUtils.js's normalizeEventApiItem, which
 * backs the single-item Add/Edit Event fetch and must stay untouched.
 */
export const normalizeEventListItem = (item) => {
  if (!item || typeof item !== "object") return item;

  return {
    id: item.id,
    eventName: item.eventName,
    eventSlug: item.eventSlug,
    thumbImage: item.thumbImage,
    displayOrder: item.displayOrder,
    eventsFrom: item.eventsFrom,
    eventsTo: item.eventsTo,
    eventLocation: item.eventLocation,
    publishedOn: item.publishedOn,
    addedOn: item.addedOn,
    status: item.status,
  };
};
